import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageCareer } from "../../components/Career/ManageCareer";

export const CareerManage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageCareer />
        </div>
      </div>
    </div>
  );
};
